<template>
	<div class="menus" style="display: flex;justify-content: center; background: #004E97;position: sticky;top: 0;z-index: 1000;">

		<a-menu  style="" v-model="current" mode="horizontal">
			<a-menu-item key="home">
				<router-link :to="{path:'/'}">首页
				</router-link>
			</a-menu-item>
			<a-menu-item key="centerProfile">
				<router-link :to="{path:'/centerProfile'}">
					平台简介
				</router-link>
			</a-menu-item>
			<a-sub-menu>
				<span slot="title" class="submenu-title-wrapper">培训考核</span>
				<a-menu-item key="trainSign" v-if="showTrain==true">
					<router-link :to="{path:'/trainSign'}">
						培训报名
					</router-link>
				</a-menu-item>
				<a-menu-item key="exam">
					<router-link :to="{path:'/exam'}">
						考试中心
					</router-link>
				</a-menu-item>
			</a-sub-menu>
			<a-sub-menu>
				<span slot="title" class="submenu-title-wrapper">动物实验</span>
				<a-menu-item key="IACUC">
					<div  @click="goToApply('/IACUC')">
						动物实验伦理申请
					</div>
				</a-menu-item>
				<a-menu-item key="aniQualification">
					<div  @click="goToaniQualification('/aniQualification')">
						动物实验中心入室申请
					</div>
				</a-menu-item>
				<a-menu-item key="animalApply">
					<div  @click="goToApply('/animalApply')">
						动物订购申请
					</div>
				</a-menu-item>
			</a-sub-menu>
			<a-sub-menu>
				<span slot="title" class="submenu-title-wrapper">开放预约</span>
				<a-menu-item key="instrument">
					<router-link :to="{path:'/instrument'}">
						仪器预约
					</router-link>

				</a-menu-item>
				<a-menu-item key="accessControl">
					<router-link :to="{path:'/accessControl'}">
					门禁预约
					</router-link>
				</a-menu-item>
				<a-menu-item key="operationRoom">
					<router-link :to="{path:'/operationRoom'}">
					场地预约
					</router-link>
				</a-menu-item>
				
			</a-sub-menu>
			<a-menu-item key="consumable">
				<router-link :to="{path:'/consumable'}">
					耗材&项目
				</router-link>
			
			</a-menu-item>
			<a-menu-item key="scientific">
				<router-link :to="{path:'/scientific'}">科研服务</router-link>
			</a-menu-item>
			<a-menu-item key="notice">
				<router-link :to="{path:'/notice'}">
					公告资讯
				</router-link>
			</a-menu-item>
			<a-menu-item key="downLoad">
				<router-link :to="{path:'/downLoad'}">
					下载中心
				</router-link>
			</a-menu-item>
			<a-menu-item key="guide">
				<router-link :to="{path:'/guide'}">
						服务指南
					</router-link>
					</a-menu-item>
			<a-menu-item key="workbench">
					<router-link v-show="Authorization" :to="{path:'/core/workbench'}">
						个人中心
					</router-link>
			</a-menu-item>
		</a-menu>
	</div>
</template>
<script>
	import {Isadministrators,SelIsShowTrain} from '@/api/index.js'
	export default {
		data() {
			return {
				current: ['home'],
				showTrain:true,
				Authorization:window.localStorage.getItem('Authorization')?window.localStorage.getItem('Authorization'):''
			};
		},
		watch: {//动态监听路由变化 -以便动态更改导航背景色事件效果等
		            '$route' (to, from) {
		              // 对路由变化作出响应...
		             this.resetMenus()
		  }
		},
		methods:{
			changeAuthorization(){
				console.log("ddd")
				this.Authorization = window.localStorage.getItem('Authorization')?window.localStorage.getItem('Authorization'):''
			},
			resetMenus(){
				let urlLength = this.$route.path.split('/').length
				if(urlLength<=2){
					let current = this.$route.path.split('/')[1]
					if(current==''){
						this.current = ['home']
					}
					else{
						this.current = [current.toString()]
					}
				}
				else if(urlLength>2){
					let current1 = this.$route.path.split('/')[urlLength-1]
					this.current = ['workbench']
				}
			},
			goToApply(url){
				var that = this
				console.log(url)
				let ifLogin = window.localStorage.getItem('Authorization')
				this.$router.push({path:url})
				// if(ifLogin){
				// 	Isadministrators().then((res)=>{
						
				// 		window.localStorage.setItem('isUser',res.data.state)
				// 		if(res.data.state==false){
							
				// 			that.$router.push({path:'/noPermission'})
				// 		}
				// 		if(res.data.state==true){
				// 			this.$router.push({path:url})
				// 		}
						
						
				// 	})
					
				// }
				// else{
				// 	this.$router.push({path:url})
				// }
				
				
			},
			goToaniQualification(url){
				var that = this
				console.log(url)
				let ifLogin = window.localStorage.getItem('Authorization')
				this.$router.push({path:url})
			}
		},
		created() {
			SelIsShowTrain().then((res)=>{
				this.showTrain = res.data.state
			})
			let ifLogin = window.localStorage.getItem('Authorization')
			if(ifLogin){
				Isadministrators().then((res)=>{
					window.localStorage.setItem('isUser',res.data.state)
				})
			}
			let urlLength = this.$route.path.split('/').length
			if(urlLength<=2){
				let current = this.$route.path.split('/')[1]
				if(current==''){
					this.current = ['home']
				}
				else{
					this.current = [current.toString()]
				}
			}
			else if(urlLength>2){
				let current1 = this.$route.path.split('/')[urlLength-1]
				this.current = ['workbench']
			}
			
			
		}
	};
</script>
<style>
	/* .menus .ant-menu-item-selected {
		background: #1890FF !important;
	} */
	.menus .ant-menu-item-selected a{
		color: white !important;
	}
	/* .menus .ant-menu-submenu-selected{
		background: transparent !important;
		color: white !important;
	} */
	.menus .ant-menu-light{
		background-color:#004E97 !important;
	}
	.menus .ant-menu-item a{
		color: white !important;
	}
	.menus .ant-menu-submenu-title{
		color: white !important;
	}
	.menus .ant-menu-submenu{
		top: 0 !important;
		margin: 0 1rem;
		
	}
	.menus .ant-menu-item{
		/* border-bottom: none !important; */
		top: 0 !important;
		margin: 0 1rem;
		
	}
	.menus .ant-menu-submenu-selected{
		border-bottom: 2px solid white !important;
		background-color: transparent !important;
	}
	.menus .ant-menu-item-selected{
		border-bottom: 2px solid white !important;
	}
	.menus .ant-menu-horizontal{
		border-bottom: none !important;
		margin: 4px 0;
	}
	/* .menus .ant-menu-item-active{
		background: #1890FF !important;
	} */
	.menus .ant-menu-submenu-active{
		background:transparent  !important;
	}
</style>
